// extracted by mini-css-extract-plugin
export default {"tvBox":"ResolutionBox__tvBox__Kj0oF","viewBox":"ResolutionBox__viewBox__zQbPX","diagnalText":"ResolutionBox__diagnalText__pWC4n","diagonalLine":"ResolutionBox__diagonalLine__M+iB1"};